<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  import MenuButton from './MenuButton.svelte';
  export let tabs = [];
  export let selected;
  let openMenu = false;
</script>

<svelte:window
  on:click={() => (openMenu = false)}
  on:blur={() => (openMenu = false)}
/>
<nav>
  <div class="container">
    <div class="tabs">
      {#each tabs as tab, i}
        <div
          class="tab"
          on:click={() => {
            dispatch('change', tab);
          }}
        >
          <MenuButton {tab} selected={tab === selected} />
        </div>
      {/each}
    </div>
    <div
      class="help-button {selected === 'help' ? 'selected' : ''}"
      on:click={() => {
        dispatch('change', 'help');
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#999"
        ><path d="M0 0h24v24H0V0z" fill="none" /><path
          d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
        /></svg
      >
    </div>
    <div
      class="settings-button"
      on:click={(e) => {
        openMenu = !openMenu;
        e.stopPropagation();
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#999"
        ><g
          ><path d="M0,0h24v24H0V0z" fill="none" /><path
            d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
          /></g
        ></svg
      >
    </div>
  </div>

  <div
    on:click={(e) => e.stopPropagation()}
    class="settings {openMenu ? 'show' : ''}"
  >
    <slot name="settings" />
  </div>
</nav>

<style>
  nav {
    box-sizing: border-box;
    height: 2.5rem;
    position: relative;
  }
  .container {
    display: grid;
    grid-template: '. . .';
    grid-template-columns: 1fr 30px 30px;
    border-bottom: 1px solid #eee;
    align-items: center;
  }
  .tabs {
    height: 100%;
    background: white;
    display: grid;
    grid-template: '. . . .';
    grid-template-columns:
      minmax(0, min-content) minmax(0, min-content)
      minmax(0, min-content) minmax(0, min-content);
  }
  .tab {
    display: inline-block;
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;
  }

  .settings-button,
  .help-button {
    cursor: pointer;
    padding: 5px 0;
    text-align: center;
    display: inline-block;
    box-sizing: border-box;
    height: 100%;
  }
  .settings {
    display: none;
    position: fixed;
    right: 20px;
    top: 45px;
  }

  .selected {
    border-bottom: 2px solid rgb(3, 155, 229);
  }
  .selected svg {
    fill: #039be5;
  }

  .show {
    display: block;
  }
</style>
